// トップページ専用のローディング処理
$(function(){
  // 画像の読み込み完了を待つ
  $(window).on('load', function(){
    // 画像読み込み完了後、loadedクラスを追加
    $('body').addClass('loaded');

    // ローディング画面を0.5秒後に削除
    setTimeout(function(){
      $('#bobson_pageloader-bg').remove();
    }, 500);

    // GSAP初期化
    if (typeof myGsapInit === "function") {
      myGsapInit();
    }
  });

  // タイムアウト: 3秒経過したら強制的に表示
  setTimeout(function(){
    if(!$('body').hasClass('loaded')){
      $('body').addClass('loaded');
      setTimeout(function(){
        $('#bobson_pageloader-bg').remove();
      }, 500);
    }
  }, 3000);
});
